import { nanoid } from '@reduxjs/toolkit';

const MESSAGE_PREFIX = 'PIM';

export const createClientMessageId = () => {
  return `${MESSAGE_PREFIX}${nanoid()}`;
};

export const isClientMessageId = (id: string) => {
  return id && `${id}`.startsWith(MESSAGE_PREFIX);
};
